import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PDFViewer, Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
import img from '../../../assets/restaurant/meteri-logo.png'
import BannerImg from '../../../assets/restaurant/BannerBg.png'

import FontBoldWoff from '../../../assets/font/Montserrat-Bold.woff';
import FontBoldWoff2 from '../../../assets/font/Montserrat-Bold.woff2';

import FontBoldWoff3 from '../../../assets/font/MontserratAlternates-MediumItalic.woff';
import FontBoldWoff4 from '../../../assets/font/MontserratAlternates-MediumItalic.woff2';

import { toast } from "react-toastify";

// Soft break words longer 
Font.registerHyphenationCallback((word) => {
    if (word.length > 15) {
        return word.match(/.{1,10}/g);
    }
    return [word];
});

Font.register({
    family: 'Montserrat',
    fonts: [
        {
            src: FontBoldWoff,
            fontWeight: 'bold',
        },
        {
            src: FontBoldWoff2,
            fontWeight: 'bold',
        },
        {
            src: FontBoldWoff3,
            fontWeight: 100,
        },
        {
            src: FontBoldWoff4,
            fontWeight: 100,
        },
    ],
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 20,
        fontSize: 12,
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundSize: 'cover',
        backgroundPosition: 'left center',
        zIndex: -1,
        opacity: 0.3,
    },
    // header: {
    //   marginBottom: 20,
    // },
    WineBorder: {
        borderTop: '1px solid #d8b6ba',
        marginBottom: 5,
        marginTop: 10,
        marginLeft: -20,
        marginRight: -20,
        paddingHorizontal: 20,
    },
    // WineListName: {
    //     maxWidth: '350px',
    //     margin: '0 auto',
    //     fontSize: 20,
    //     textAlign: 'left',
    //     color: '#7d0a0a',
    //     fontWeight: 'bold',
    //     fontFamily: 'Montserrat',
    //     textTransform: 'capitalize',
    //     wordWrap: 'break-word',
    //     overflow: 'hidden',
    //     maxHeight: '70px',
    // },

    WineListName: {
        maxWidth: '310px',
        // margin: '0 auto',
        margin: '20px auto 10px',
        fontSize: 18,
        textAlign: 'left',
        color: '#7d0a0a',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
        textTransform: 'capitalize',
        wordWrap: 'break-word',
        overflow: 'hidden',
        maxHeight: '70px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    WineListDescription: {
        maxWidth: '480px',
        margin: '0 auto',
        marginBottom: -20,
        fontSize: 11,
        textAlign: 'left',
        color: '#7d0a0a',
        fontWeight: 100,
        fontFamily: 'Montserrat',
        textTransform: 'capitalize',
        wordWrap: 'break-word',
        overflow: 'hidden',
        lineHeight: '13px',
    },
    wineType: {
        fontSize: 12,
        color: '#5f5f5f',
        fontWeight: 'bold',
        marginTop: 12,
        marginLeft: 35,
    },
    regionType: {
        fontSize: 15,
        color: '#5f5f5f',
        fontWeight: 'bold',
        marginBottom: 5,
        textAlign: 'left',
        marginLeft: 20,
    },
    wineCard: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingBottom: 15,
        paddingTop: 5,
        gap: 10,
        // borderBottom: '1px solid #f0f0f0',
        pageBreakInside: 'avoid',
    },
    dishImageContainer: {
        width: 90,
        height: 90,
        borderRadius: 60,
        overflow: 'hidden',
        marginRight: 20,
        marginTop: 10,
        backgroundColor: '#f0f0f0',
    },
    nodishImageFound: {
        marginLeft: 22,
    },
    dishImage: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover',
    },
    // mainimg: {
    //     width: 50,
    //     height: 115,
    //     marginRight: 15,
    // },
    LogoImage: {
        width: 105,
        height: 45,
        position: 'absolute',
        top: 12,
        left: 15,
        zIndex: 10
    },
    LogoImage1: {
        width: 105,
        height: 45,
        position: 'absolute',
        top: 12,
        right: 15,
        zIndex: 10
    },
    wineDetails: {
        flex: 1,
        paddingTop: 15
    },
    wineName: {
        fontSize: 12,
        color: '#7d0a0a',
        marginBottom: 5,
        fontWeight: 'bold',
    },
    allergensMenu: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: 5,
    },
    // wineDescription: {
    //     fontSize: 9,
    //     color: '#000000',
    //     marginBottom: 5,
    //     textAlign: 'justify',
    //     lineHeight: 1.3,
    //     maxWidth:'500px'
    // },
    wineDescription: {
        fontSize: 9,
        color: '#000000',
        marginBottom: 5,
        textAlign: 'justify',
        lineHeight: 1.3,
        // maxWidth is optional depending on your layout needs
        maxWidth: 400,

        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1,
        flexBasis: 0,
    },

    wineAddress: {
        fontSize: 10,
        color: '#5f5f5f',
        marginBottom: 8,
        fontWeight: 'bold',
    },
    winePrice: {
        fontSize: 12,
        marginLeft: "auto",
        marginTop: 20,
        fontWeight: 'bold',
        color: '#8B2434',
    },
    halfPriceContainer: {
        display: 'flex',
        marginTop: 10,
    },
    priceLabel: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#6B6B6B',
        // marginRight: 8, 
    },
    winePrice1: {
        fontSize: 12,
        // marginTop: 6,
        marginLeft: "auto",
        fontWeight: 'bold',
        color: '#8B2434',
    },
    noWinesContainer: {
        marginTop: 20,
        textAlign: "center",
    },
    noWinesText: {
        fontSize: 16,
        fontWeight: "bold",
        color: "red",
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        fontSize: 12,
        fontWeight: 'bold',
        width: "100%",
        height: "12px",
        backgroundColor: "#8B2434"
    },
    pageContent: {
        flex: 1,
        // marginBottom: 20,
        marginBottom: 10,
        // marginLeft:10,
        // marginRight: 10,
        marginTop: 25,
    },
    fullWidthContent: {
        marginLeft: -20,
        marginRight: -20,
        paddingHorizontal: 20,
    },
    dishContainer: {
        marginBottom: 30
    },

});

const MenuPDF = () => {
    const { menu_id } = useParams();
    const [menuData, setMenuData] = useState(null);
    const [dishImagesLoaded, setDishImagesLoaded] = useState({});
    const [loading, setLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);

    const token = localStorage.getItem("token");
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
    const logo = menuData?.menu?.
        restaurant?.logo ? `${logoUrl}/${menuData?.menu?.restaurant?.logo}` : null;


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${apiUrl}/api/v1/menu-dishes/${menu_id}`);
                if (res.status === 200) {
                    setMenuData(res.data);

                    const dishImages = res.data?.dishes
                        ?.map((dish) => ({
                            id: dish.id,
                            url: dish.picture ? `${logoUrl}/${dish.picture}` : null
                        }))
                        .filter(dish => dish.url);

                    if (dishImages.length > 0) {
                        const imagePromises = dishImages.map((dishImage) =>
                            axios.get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(dishImage.url)}`, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                                responseType: "blob",
                            })
                                .then((res) => {
                                    if (res.status === 200) {
                                        const imageBlobUrl = URL.createObjectURL(res.data);
                                        setDishImagesLoaded((prev) => ({
                                            ...prev,
                                            [dishImage.id]: imageBlobUrl
                                        }));
                                    }
                                })
                                .catch((error) => {
                                    console.error('Error loading image:', dishImage.url, error);
                                    return null;
                                })
                        );

                        await Promise.all(imagePromises);
                    }
                } else {
                    setMenuData(null);
                }
            } catch (err) {
                console.error(err);
                setMenuData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [menu_id, logoUrl]);

    // console.log(menuData, "menuData")

    // const stripHtmlTags = (html) => {
    //     const tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = html;
    //     return tempDiv.textContent || tempDiv.innerText || '';
    // };

    const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
    };


    // const renderWineCard = (item) => (
    //     <View style={[styles.wineCard, styles.fullWidthContent]} key={item?.wine?.id}>
    //         <View style={styles.mainimg}>
    //             {item?.wine?.image && imageLoaded[item?.wine?.id] ? (
    //                 <Image
    //                     source={{ uri: imageLoaded[item?.wine?.id] }}
    //                     style={styles.image}
    //                 />
    //             ) : (
    //                 <Image source={bottle} style={styles.image} />
    //             )}
    //         </View>

    //         <View style={styles.wineDetails}>
    //             <Text style={styles.wineName}>{item?.wine?.name || ""}</Text>
    //             <Text style={styles.wineAddress}>
    //                 {item?.wine?.region && <Text style={{ fontWeight: 'bold' }}>Region: </Text>}{item?.wine?.region}
    //                 {item?.wine?.region && item?.wine?.nation ? ", " : ""}
    //                 {item?.wine?.nation && <Text style={{ fontWeight: 'bold' }}>Nation: </Text>} {item?.wine?.nation}
    //                 {(item?.wine?.region || item?.wine?.nation) && item?.wine?.grape_variety ? ", " : ""}
    //                 {item?.wine?.grape_variety && <Text style={{ fontWeight: 'bold' }}>Grape Variety: </Text>} {item?.wine?.grape_variety}
    //             </Text>
    //             <Text style={styles.wineDescription}>
    //                 {stripHtmlTags(item?.wine?.short_description || "")}
    //             </Text>
    //         </View>

    //         <View style={{ width: "14%", gap: 5 }}>
    //             {item?.pivot?.is_show_bottle_price && (
    //                 <Text style={styles.winePrice}>
    //                     <Image source={bottle} style={{ width: 10, height: 10 }} />
    //                     {" €" + item?.pivot?.bottle_price}
    //                 </Text>
    //             )}
    //             {item?.pivot?.is_show_glass_price && (
    //                 <Text style={styles.winePrice1}>
    //                     <Image source={glass} style={{ width: 10, height: 10 }} />
    //                     {" €" + item?.pivot?.glass_price}
    //                 </Text>
    //             )}
    //         </View>
    //     </View>
    // );

    const handleMobileDownload = async () => {
        try {
            setIsDownloading(true);
            const { pdf } = await import('@react-pdf/renderer');
            const blob = await pdf(
                <Document>
                    {renderPages()}
                </Document>
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `menu-list-${new Date().toISOString().slice(0, 10)}.pdf`;
            document.body.appendChild(link);
            link.click();

            // Show success toast
            toast.success('Menu list successfully downloaded', {
                position: "top-center",
                autoClose: 1000,
                theme: 'colored',
            });

            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                setIsDownloading(false);
            }, 100);
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setIsDownloading(false);

            // Show error toast
            toast.error('Failed to download Menu list', {
                position: "top-center",
                autoClose: 2000,
                theme: 'colored'
            });
        }
    };

    const renderDishCard = (dish) => (
        <View style={[styles.wineCard, styles.fullWidthContent]} key={dish.id}>
            {/* <View style={styles.dishImageContainer}>
                {dish?.picture ? (
                    <Image
                        src={{
                            uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(`${logoUrl}/${dish.picture}`)}`,
                            method: "GET",
                            headers: { Authorization: `Bearer ${token}` },
                        }}
                        style={styles.dishImage}
                    />
                ) : (
                    <Image source="" style={styles.image} />
                )}
            </View> */}

            <View style={dish?.picture ? styles.dishImageContainer : styles.nodishImageFound}>
                {dish?.picture ? (
                    <Image
                        src={{
                            uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(`${logoUrl}/${dish.picture}`)}`,
                            method: "GET",
                            headers: { Authorization: `Bearer ${token}` },
                        }}
                        style={styles.dishImage}
                    />
                ) : (
                    <Image source="" />
                )}
            </View>
            <View style={styles.wineDetails}>
                <Text style={styles.wineName}>{dish?.name || ""}</Text>
                {dish?.allergens?.length > 0 && (
                    <Text style={styles.allergensMenu}>
                        {dish.allergens.map(allergen => allergen?.name_it).join(", ")}
                    </Text>
                )}
                <Text style={styles.wineDescription}>
                    {/* {stripHtmlTags(dish.description || "")} */}
                    {truncateText((dish.description || "").replace(/[\r\n]+/g, " "), 320)}

                </Text>
                {/* <Text
                    style={styles.wineDescription}
                    numberOfLines={5}
                    // ellipsizeMode="tail"
                >
                    {stripHtmlTags(dish.description)}
                </Text> */}

            </View>
            <View style={{ width: "26%", gap: 5 }}>
                {dish?.pivot?.is_option_to_be_full_dish === 1 && (
                    <View>
                        {/* <Text style={styles.priceLabel}>Full Price:</Text> */}
                        <Text style={styles.winePrice}>
                            {dish?.pivot?.full_price || ""} €
                        </Text>
                    </View>
                )}
                {dish?.pivot?.is_option_to_be_half_dish === 1 && (
                    <View style={styles.halfPriceContainer}>
                        <Text style={styles.priceLabel}>Mezza Porzione: <Text style={styles.winePrice1}>
                            {dish?.pivot?.half_price || ""} €
                        </Text></Text>

                    </View>
                )}
            </View>
            <View >
            </View>
        </View>
    );

    const renderPages = () => {

        if (!menuData?.dishes?.length) {
            return (
                <Page size="A4" style={styles.page}>
                    <Image style={styles.backgroundImage} src={BannerImg} fixed />
                    {logo && (
                        <Image
                            src={{
                                uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
                                method: "GET",
                                headers: { Authorization: `Bearer ${token}` },
                            }}
                            style={styles.LogoImage}
                        />
                    )}
                    <Image style={styles.LogoImage1} src={img} fixed />
                    <Text style={styles.footer} fixed />
                    <Text style={styles.WineListName}>{""}</Text>
                    <View style={styles.noWinesContainer}>
                        <Text style={styles.noWinesText}>No Dish found.</Text>
                    </View>
                </Page>
            );
        }

        // const pages = [];
        // let currentPageContent = [];
        // let currentDishCount = 0;
        // const displayedTitles = new Set();

        // if (menuData?.dishes?.length) {
        //     menuData.dishes.forEach((dish) => {
        //         const title = dish?.dish_courses?.[0]?.name;
        //         const shouldRenderTitle = !displayedTitles.has(title);

        //         // Check if we need to start a new page
        //         if (currentDishCount > 0 && currentDishCount + (shouldRenderTitle ? 2 : 1) > 4) {
        //             pages.push(currentPageContent);
        //             currentPageContent = [];
        //             currentDishCount = 0;
        //             displayedTitles.clear();
        //         }

        //         if (shouldRenderTitle) {
        //             displayedTitles.add(title);
        //             currentPageContent.push(
        //                 <View key={`title-${title}`} style={styles.WineBorder}>
        //                     <Text style={styles.wineType}>{title}</Text>
        //                     {/* <View style={styles.divider} /> */}
        //                 </View>
        //             );
        //             currentDishCount++;
        //         }

        //         currentPageContent.push(renderDishCard(dish));
        //         currentDishCount++;
        //     });

        //     // Add the last page if it has content
        //     if (currentPageContent.length > 0) {
        //         pages.push(currentPageContent);
        //     }
        // }


        const pages = [];
        let currentPageContent = [];
        let currentDishCount = 0;
        const displayedTitles = new Set();
        let currentTitle = null;

        if (menuData?.dishes?.length) {
            menuData.dishes.forEach((dish) => {
                const title = dish?.dish_courses?.[0]?.name;

                // Check if we need to start a new page (only based on dish count)
                if (currentDishCount >= 4) {
                    pages.push(currentPageContent);
                    currentPageContent = [];
                    currentDishCount = 0;
                    displayedTitles.clear();
                    currentTitle = null;
                }

                // Add title if it's new and we're at the start of a page or it's changed
                if (title !== currentTitle) {
                    currentTitle = title;
                    currentPageContent.push(
                        <View key={`title-${title}`} style={styles.WineBorder}>
                            <Text style={styles.wineType}>{title}</Text>
                        </View>
                    );
                    // Don't count title towards dish count
                }

                currentPageContent.push(renderDishCard(dish));
                currentDishCount++;
            });

            // Add the last page if it has content
            if (currentPageContent.length > 0) {
                pages.push(currentPageContent);
            }
        }

        // const pages = [];
        // let currentPageContent = [];
        // let currentDishCount = 0;
        // const displayedTitles = new Set();

        // if (menuData?.dishes?.length) {
        //     // First group dishes by their course titles
        //     const dishesByCourse = {};
        //     menuData.dishes.forEach(dish => {
        //         const title = dish?.dish_courses?.[0]?.name || '';
        //         if (!dishesByCourse[title]) {
        //             dishesByCourse[title] = [];
        //         }
        //         dishesByCourse[title].push(dish);
        //     });

        //     // Process each course group
        //     Object.entries(dishesByCourse).forEach(([title, dishes]) => {
        //         let dishesInTitle = [...dishes];

        //         while (dishesInTitle.length > 0) {
        //             // Start new page if current page is full
        //             if (currentDishCount >= 4) {
        //                 pages.push(currentPageContent);
        //                 currentPageContent = [];
        //                 currentDishCount = 0;
        //             }

        //             // Add title header at the start of each page
        //             if (currentDishCount === 0) {
        //                 currentPageContent.push(
        //                     <View key={`title-${title}-${pages.length}`} style={styles.WineBorder}>
        //                         <Text style={styles.wineType}>{title}</Text>
        //                     </View>
        //                 );
        //             }

        //             // Add dishes until page is full or group is exhausted
        //             while (currentDishCount < 4 && dishesInTitle.length > 0) {
        //                 const dish = dishesInTitle.shift();
        //                 currentPageContent.push(renderDishCard(dish));
        //                 currentDishCount++;
        //             }
        //         }
        //     });

        //     // Add the last page if it has content
        //     if (currentPageContent.length > 0) {
        //         pages.push(currentPageContent);
        //     }
        // }

        return pages.map((pageContent, index) => (
            <Page key={`page-${index}`} size="A4" style={styles.page}>
                <Image style={styles.backgroundImage} src={BannerImg} fixed />
                {logo && index === 0 && (
                    <Image
                        src={{
                            uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
                            method: "GET",
                            headers: { Authorization: `Bearer ${token}` },
                        }}
                        style={styles.LogoImage}
                    />
                )}
                <Image style={styles.LogoImage1} src={img} fixed />
                {/* {index === 0 && <Text style={styles.WineListName}>{menuData?.menu?.name || ""}</Text>} */}

                {index === 0 && <Text style={styles.WineListName}>
                    {truncateText((menuData?.menu?.name || ""), 60)}
                </Text>}

                {index === 0 && menuData?.menu?.show_description && (
                    <Text style={styles.WineListDescription}>
                        {truncateText((menuData?.menu?.description || "").replace(/[\r\n]+/g, " "), 200)}
                    </Text>
                )}

                <View style={styles.pageContent}>
                    {pageContent}
                </View>
                <Text style={styles.footer} fixed />
            </Page>
        ));
    };

    if (loading) {
        return <div className="flex justify-center items-center h-screen">
            <svg
                aria-hidden="true"
                className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                />
            </svg>
            <span className="sr-only">Loading...</span>
        </div>
    }

    if (isMobile) {
        return (
            <div className="flex flex-col items-center justify-center h-screen p-4">
                <div className="text-center">

                    <button
                        onClick={handleMobileDownload}
                        disabled={isDownloading}
                        className="px-4 py-2 bg-[#8A2533] text-white rounded-md flex items-center justify-center"
                    >
                        {isDownloading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Downloading...
                            </>
                        ) : (
                            'Download PDF'
                        )}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <PDFViewer style={{ width: '100%', height: '100vh' }}>
            <Document>
                {renderPages()}
            </Document>
        </PDFViewer>

    );
};

export default MenuPDF;